import React from 'react';
import { Box, CircularProgress, Switch, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';
import LoadBar from '../../../../../utils/LoadBar';


function Appflyte({ setAppflyteData, appflyteData }) {
    const theme = useTheme();
    const styles = getStyles(theme);


    const handleSwitchChange = (item) => {
        setAppflyteData(prev => {
            const id = item?.payload?.__auto_id__;
            const isSelected = prev.selected_schemas?.some(schema => schema?.payload?.__auto_id__ === id);
            return {
                ...prev,
                selected_schemas: isSelected ? prev.selected_schemas.filter(schema => schema?.payload?.__auto_id__ !== id) : [...(prev.selected_schemas ?? []), item]
            };
        });
    };

    return (
        <Box>

            {appflyteData.loading && <LoadBar />}


            <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>Select Project <span style={{ color: 'red' }}>*</span></Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '50px', marginTop: '10px' }}>

                {appflyteData.loading ?
                    (<Box sx={{ textAlign: 'center', marginTop: '50px' }}>
                        <CircularProgress sx={{ color: '#0B51C5' }} />
                    </Box>)
                    :
                    (appflyteData.appflyte_schemas || [])?.length > 0 ? (appflyteData.appflyte_schemas?.map(item => (
                        <Box sx={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px',
                            width: '40%', border: '1px solid #D9D9D9', borderRadius: '10px', marginBottom: '20px'
                        }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>
                                {item?.payload?.name}
                            </Typography>
                            <Switch
                                checked={appflyteData.selected_schemas?.some((project) => project?.payload?.__auto_id__ === item?.payload?.__auto_id__)}
                                onChange={() => handleSwitchChange(item)}
                            />
                        </Box>
                    )))
                        :
                        (<Typography sx={{ textAlign: 'center', marginTop: '50px' }}>No Projects Available</Typography>)
                }
            </Box>

        </Box>
    )
}


export default Appflyte;